import React, { Component } from 'react'
import { Calendar } from 'fullcalendar'
import $ from 'jquery'
import './App.css'

const shortMonthToLongMonthMapping = {
  "Jan": "January",
  "Feb": "February",
  "Mar": "March",
  "Apr": "April",
  "May": "May",
  "Jun": "June",
  "Jul": "July",
  "Aug": "August",
  "Sep": "September",
  "Oct": "October",
  "Nov": "November",
  "Dec": "December",
}

const toRGB = s => s.replace(/[^\d,]/g, '').split(',').map(v => parseInt(v))
const transparent = (components, opacity) => `rgba(${[...toRGB(components), opacity].join(',')})`
class App extends Component {

  createCalendar = (containerElement) => {    
    if (this.calendar) return
    this.calendar = new Calendar(containerElement, {      
      defaultView: 'agendaWeek',
      nowIndicator: true,      
      height: window.innerHeight - 30,
      events: [
        {
          title  : '',
          start  : '2019-01-28',
          color: '#2cfa9a',

        },
        {
          color: '#0cfa9a',
          title  : '',
          start  : '2019-01-28',
          end  : '2019-01-29'
        },
        {
          title  : '',
          color: '#fcea9a',
          start  : '2019-01-28T12:00:00',
          allDay : false,
          end  : '2019-01-28T14:20:00'
        },
        {
          title  : '',
          color: '#7f90a3',
          start  : '2019-01-29T12:20:00',
          allDay : false,
          end  : '2019-01-29T14:40:00',
        },
        {
          title  : '',
          color: '#1eaef5',
          start  : '2019-01-27T12:30:00',
          allDay : false,
          end  : '2019-01-27T14:50:00',
        }
      ]
    });
    this.calendar.render()

    $('.fc-time-grid-event').each((index, event) => {
      const colorString = event.style["background-color"] 
      const $content = $(event).find(".fc-content")
      $content.css("color", colorString)

      const $time = $content.find(".fc-time")
      const times = $time.text().split("-")
      $time.text(times[0].trim())
      event.style["background-color"] = transparent(colorString, 0.33)
    })

    $('.fc-day-grid-event').each((index, event) => {
      const colorString = event.style["background-color"] 
      const $content = $(event).find(".fc-content")
      $content.css("color", colorString)
      event.style["background-color"] = transparent(colorString, 0.33)
    })

    const $month = $('.fc-left').find('h2')
    const shortMonth = $month.text().split(" – ")[0].split(" ")[0]
    const newTitle = [
      "<span style='font-weight: 700'>" + shortMonthToLongMonthMapping[shortMonth] + "</span>",
      new Date().getFullYear()
    ].join(" ")
    $month.html(newTitle)

    $(".fc-day-header span").each((index, date) => {
      const $date = $(date)
      const dateString = $date.text()
      const dayOfWeek = dateString.split(" ")[0]
      const monthDate = dateString.split("/")[1]
      $date.text(`${dayOfWeek} ${monthDate}`)
    })

    $(".fc-slats .fc-time span").each((index, time) => {
      const $time = $(time)
      const timeString = $time.text()
      let hour = parseInt(timeString.substring(0, timeString.length - 2))
      const ampm = timeString.substring(timeString.length - 2, timeString.length)

      if (ampm === "pm") {
        hour += 12
      }

      $time.text(`${hour}:00`)
    })
  }

  render() {
    return (
      <div className="App" ref={this.createCalendar}>
        
      </div>
    )
  }
}

export default App
